/* Mobile menu department pages (snippets/header-menu-drawer.liquid). A department row opens its page in place
   of the list; "All departments" goes back. Each time the menu opens it starts at the list. */
(function () {
  function loadPhotos(panel) {
    panel.querySelectorAll('img[data-kp-panel-src]').forEach(function (img) {
      if (img.dataset.kpPanelSrcset) img.srcset = img.dataset.kpPanelSrcset;
      img.src = img.dataset.kpPanelSrc;
      img.removeAttribute('data-kp-panel-src');
    });
  }
  function show(nav, panel, opener, focus) {
    var list = nav.querySelector('[data-kp-mnav-root]');
    nav.querySelectorAll('.kp-mnav__panel').forEach(function (p) { p.hidden = p !== panel; });
    nav.querySelectorAll('[data-kp-mnav-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', panel && b === opener ? 'true' : 'false');
    });
    if (list) list.hidden = !!panel;
    nav.scrollTop = 0;
    if (panel) loadPhotos(panel);
    if (!focus) return;
    var target = panel ? panel.querySelector('[data-kp-mnav-back]') : opener;
    if (target) target.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target : null;
    var nav = el && el.closest('[data-kp-mnav]');
    if (!nav) return;
    var opener = el.closest('[data-kp-mnav-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('aria-controls'));
      if (panel) show(nav, panel, opener, true);
      return;
    }
    var back = el.closest('[data-kp-mnav-back]');
    if (back) {
      var current = back.closest('.kp-mnav__panel');
      show(nav, null, current && nav.querySelector('[aria-controls="' + current.id + '"]'), true);
    }
  });
  function watch() {
    var drawer = document.getElementById('m-menu-drawer');
    var nav = drawer && drawer.querySelector('[data-kp-mnav]');
    if (!nav || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!drawer.hasAttribute('inert') && nav.querySelector('.kp-mnav__panel:not([hidden])')) show(nav, null, null, false);
    }).observe(drawer, { attributes: true, attributeFilter: ['inert'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
})();
